import { Status } from "../../models/Status";

export const CHANGE_PASSWORD_STATUS = "CHANGE_PASSWORD_STATUS";

export type IState = {
  status: Status;
};
